import axios from 'axios'
import { IN_PRODUCT } from '../config/product'

axios.defaults.baseURL = IN_PRODUCT ? 'https://revart.co' : 'http://localhost:8000'
axios.defaults.headers.common['accept'] = 'application/json'

export default axios
